var AuthPlugin={
    setToken:function(token, expiration, roleId, role, aimp){
        localStorage.setItem('authToken', token);
        localStorage.setItem('authTokenExpiration', expiration);
        localStorage.setItem('roleToken',roleId);
        localStorage.setItem('role',role);
        localStorage.setItem('autImport', aimp);
    },

    destroyToken:function(){
        localStorage.removeItem('authToken');
        localStorage.removeItem('authTokenExpiration');
        localStorage.removeItem('roleToken');
        localStorage.removeItem('role');
        localStorage.removeItem('autImport');
    },
    
    getAutImp:function(){
        return localStorage.getItem('autImport'); 
    },

    getToken:function(){
        var token = localStorage.getItem('authToken');
        var expiration = localStorage.getItem('authTokenExpiration');

        if( !token || !expiration){
            return null;
        }

        if(Date.now() > parseInt(expiration)){
            this.destroyToken();
            return null;
        }else{
            return token;
        }
    },

    loggedIn:function(){
        
        if(this.getToken()){
            return true;
        }else{
            return false;
        }
    }    
};

export default function(Vue){
    Vue.auth= AuthPlugin;

    Object.defineProperties(Vue.prototype, {
        $auth:{
            get:function(){
                return Vue.auth;
            }
        }
    })
}


// WEBPACK FOOTER //
// ./src/plugins/Auth.js